module.exports = __webpack_public_path__ + "static/img/img1.f76d98e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/person/img1.png
// module id = g6S4
// module chunks = 1